import { CategoryData, CategoryType } from '../revamp/types/PatientFormTypes';
import userService from './userService';
import { toast } from 'react-toastify';
import { 
  generateFollowUpPDF,
  generateNewPatientPDF,
  generateWeightManagementPDF,
  generateWMFollowUpPDF,
  generateGenericFormPDF
} from "../revamp/utils/PDFGenerators";

type FormDetails = {
	title: string;
	userId: string;
	usedFor?: string;
	fileCategory?: string;
}

class PDFService {
  static async generatePDF(
    formType: string,
    patientId: string,
    formData: Record<CategoryType, CategoryData>
  ): Promise<Blob> {
    console.log("Generating PDF for form type:", formType);
    console.log("Form data:", formData);

    // Get patient data
    const patient = await userService.getUser(patientId)
			.then((res) => res.data)
			.catch((err) => {
				console.error("Error fetching patient", err);
				return null;
			});

    if (!patient) {
      throw new Error(`Could not generate PDF: Patient with id=${patientId} not found`);
    }

    // Generate PDF based on form type
    let pdf;
    switch (formType) {
      case "newPatient":
        pdf = generateNewPatientPDF(patient, formData);
        break;
      case "followUp":
        pdf = generateFollowUpPDF(patient, formData);
        break;
      case "weightManagement":
        pdf = generateWeightManagementPDF(patient, formData);
        break;
      case "wmFollowUp":
        pdf = generateWMFollowUpPDF(patient, formData);
        break;
      case "generic":
        pdf = generateGenericFormPDF(patient, formData);
        break;
      default:
        throw new Error(`Unsupported form type: ${formType}`);
    }

    // Convert to blob
    return pdf.output('blob');
  }

  static async openPDFInNewTab(pdf: Blob): Promise<void> {
    const url = URL.createObjectURL(pdf);
    window.open(url, '_blank');
  }

  static async downloadPDF(pdf: Blob, details: FormDetails) {
    const url = URL.createObjectURL(pdf);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${details.title}.pdf`;
    a.click();
  }

	static async savePDF(pdf: Blob, details: FormDetails) {
		const file = new File(
      [pdf],
      `${details.title}.pdf`,
      { type: 'application/pdf' },
    );

    const body = {
      category: details.fileCategory || 'OTHER',
      patientId: details.userId,
      usedFor: details.usedFor || 'patient form',
    };

    await userService.createForm(file, body)
      .catch(err => toast.error(err.message));
	}
}

export default PDFService;
